/**
 * Generates a random string of specified length
 * @param length - The length of the random string to generate
 * @returns A random string containing alphanumeric characters
 */
export const generateRandomString = (length: number): string => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

/**
 * Generates a random string containing only uppercase letters and numbers
 * @param length - The length of the random string to generate
 * @returns A random string containing only uppercase letters and numbers
 */
export const generateRandomCode = (length: number): string => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};
